class Accordion {
    constructor(heading) {
        this.heading = heading;
    }

    showAll() {
        const accordionHeading = document.querySelectorAll(this.heading);
        accordionHeading.forEach(item => {
            item.addEventListener('click', () => {
                item.classList.contains('active')
                    ? item.classList.remove('active')
                    : item.classList.add('active');
            });
        });
    }
}

class ProductAccordion {
    constructor(heading) {
        this.heading = heading;
    }

    showAll() {
        const accordionHeading = document.querySelectorAll(this.heading);
        accordionHeading.forEach(item => {
            item.addEventListener('click', () => {
                item.classList.contains('active')
                    ? item.classList.remove('active')
                    : item.classList.add('active');
                if(item.classList.contains('active')) {
                    accordionHeading.forEach(accordionItem => {
                        if(item !== accordionItem) {
                            accordionItem.classList.remove('active');
                        }
                    });
                }
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const footerAccordionBreakpoint = window.matchMedia(`(max-width:750px)`);
    if (footerAccordionBreakpoint.matches == true) {
        const accordion = new Accordion('.menu-footer-heading');
        accordion.showAll();
    }

    const productAccordion = new ProductAccordion('.product__accordion-heading');
    const cartOrderAccordion = new ProductAccordion('.cartOrder__accordion-heading');
    productAccordion.showAll();
    cartOrderAccordion.showAll();
});